var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group",class:{
        'form-group--error': _vm.error
    }},[_c('div',{staticClass:"form-group__grid"},[(_vm.label)?_c('div',{staticClass:"form-group__label-wrapper"},[_c('label',{staticClass:"form-group__label",domProps:{"textContent":_vm._s(_vm.label)}})]):_vm._e(),_c('div',{staticClass:"form-group__item-wrapper",class:{
                'form-group__item-wrapper--offset': !_vm.label && _vm.offset,
                'form-group__item-wrapper--fullwidth': !_vm.label && !_vm.offset
            }},[_vm._t("default")],2),(_vm.$slots['help-text'])?_c('div',{staticClass:"form-group__help-text",class:{
                'form-group__help-text--fullwidth': !_vm.label && !_vm.offset,
            }},[_vm._t("help-text")],2):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }